import { store } from '@/store/store';
import { ProductoAmazon } from '@/shared/dtos/productosAmazon/ProductoAmazon';
import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action
} from 'vuex-module-decorators';
import { ssmHttpService } from '@/shared/services/http-service';
import { API } from '@/shared/api';
import ocultarcamposModule from './ocultarcampos-module';
import { ProcessoNums } from '@/views/procesos/ProcessoNums';
import router from '@/router/router';

@Module({
    namespaced: true,
    name: 'TiendaOnlineClientesModule',
    store,
    dynamic: true
})
class TiendaOnlineClientesModule extends VuexModule {
    public TiendaOnlineClienteses: ProductoAmazon[] = [];
    public TiendaOnlineClientes: ProductoAmazon = new ProductoAmazon();
    public searchQuery = "";
    public totalProductos = 0; // Variable para almacenar el total de productos
    public TiendaProductosCahe: ProductoAmazon[] = [];

    @Action({ commit: 'onGetTiendaOnlineClienteses' })
    public async getTiendaOnlineClienteses() {
        return await ssmHttpService.get(API.TiendaOnlineClientes + '/productos_tienda_online');
    }

    @Action({ commit: 'onGetTiendaOnlineClienteses' })
    public async getTiendaOnlineClientesesTodos() {
        return await ssmHttpService.get(API.TiendaOnlineClientes + '/productos_tienda_online_all/');
    }

    @Action({ commit: 'onGetTiendaOnlineClientesesPaginacion' })
    public async getTiendaOnlineClientesesTodosPaginacion({ skip, take, selectedProcessoNumber, search }: { skip: number, take: number, selectedProcessoNumber: number, search: string }) {
        return await ssmHttpService.get(API.TiendaOnlineClientes + '/productos_tienda_online_all' + '?skip=' + skip + '&take=' + take + '&selectedProcessoNumber=' + selectedProcessoNumber + '&search=' + search+'&mayorista='+ (router.currentRoute.meta.mayorista ? '1' : '0'));
    }
    @Action({})
    public async getTiendaOnlineClientesesTodosPaginacionSinAction({ skip, take, selectedProcessoNumber, search }: { skip: number, take: number, selectedProcessoNumber: number, search: string }) {
        return await ssmHttpService.get(API.TiendaOnlineClientes + '/productos_tienda_online_all' + '?skip=' + skip + '&take=' + take + '&selectedProcessoNumber=' + selectedProcessoNumber + '&search=' + search+'&mayorista='+ (router.currentRoute.meta.mayorista ? '1' : '0'));
    }

    @Action({ commit: 'onGetTiendaOnlineClientes' })
    public async getTiendaOnlineClientes(id: any) {
        return await ssmHttpService.get(API.TiendaOnlineClientes + '/producto_tienda_online/' + id+ '/'+ (router.currentRoute.meta.mayorista ? '1' : '0'));
    }
    
    @Action({ commit: 'onGetTiendaOnlineClientes' })
    public async getTiendaOnlineClientesSilence(id: any) {
        return await ssmHttpService.get(API.TiendaOnlineClientes + '/producto_tienda_online/' + id+'/'+ (router.currentRoute.meta.mayorista ? '1' : '0'),null,false);
    }
    @Action({ commit: 'onSetSearchQuery' })
    public async SetSearchQuery(dato: string) {
        return dato;
    }

    @Action({ rawError: true })
    public async getEstadosProductos(ids: number[]): Promise<any> {
        try {
            return await ssmHttpService.post(API.producto + '/estados', ids, false);
        } catch (e) {
            console.error(e);
            return {};
        }
    }

    @Mutation
    public onGetTiendaOnlineClienteses(res: ProductoAmazon[]) {
        this.TiendaOnlineClienteses = res ? res.map((x) => new ProductoAmazon(x)) : [];

        if (this.TiendaOnlineClienteses.length > 0) {
            if (ocultarcamposModule.Ocultar_tarjeta_efectivo) {
                this.TiendaOnlineClienteses = this.TiendaOnlineClienteses.filter(x => x.estado !== ProcessoNums.VendidoEfectivo);
            }
        }

    }
    @Mutation
    public onGetTiendaOnlineClientesesPaginacionNuevosADD(res: { Productos: ProductoAmazon[], Total: number }) {
        // Ahora tienes 'Productos' y 'Total' dentro del objeto 'res'
        var prodcutos_nuevos = res.Productos ? res.Productos.map((x) => new ProductoAmazon(x)) : [];

        if (prodcutos_nuevos.length > 0) {
            if (ocultarcamposModule.Ocultar_tarjeta_efectivo) {
                prodcutos_nuevos = prodcutos_nuevos.filter(x => x.estado !== ProcessoNums.VendidoEfectivo);
            }
        }
        this.TiendaOnlineClienteses.push(...prodcutos_nuevos); // Agrega los nuevos productos a la lista existente

        // Puedes usar 'res.Total' si necesitas el total de productos
        this.totalProductos = res.Total;  // Esto guarda el total de productos en alguna variable si la necesitas
    }

    @Mutation
    public onGetTiendaOnlineClientesesPaginacion(res: { Productos: ProductoAmazon[], Total: number }) {
        // Ahora tienes 'Productos' y 'Total' dentro del objeto 'res'
        this.TiendaOnlineClienteses = res.Productos ? res.Productos.map((x) => new ProductoAmazon(x)) : [];

        if (this.TiendaOnlineClienteses.length > 0) {
            if (ocultarcamposModule.Ocultar_tarjeta_efectivo) {
                this.TiendaOnlineClienteses = this.TiendaOnlineClienteses.filter(x => x.estado !== ProcessoNums.VendidoEfectivo);
            }
        }

        // Puedes usar 'res.Total' si necesitas el total de productos
        this.totalProductos = res.Total;  // Esto guarda el total de productos en alguna variable si la necesitas
    }


    @Mutation
    public onGetTiendaOnlineClientes(res: ProductoAmazon) {
        this.TiendaOnlineClientes = new ProductoAmazon(res);
    }
    @Mutation
    public onSetSearchQuery(res: string) {
        this.searchQuery = res;
    }
    @Mutation
    public onSetCache(res: ProductoAmazon[]) {
        this.TiendaProductosCahe = res;
    }
}
export default getModule(TiendaOnlineClientesModule);